// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AttachmentController from "./attachment_controller"
application.register("attachment", AttachmentController)

import AutoRemoveController from "./auto_remove_controller"
application.register("auto-remove", AutoRemoveController)

import Components__CollapseController from "./components/collapse_controller"
application.register("components--collapse", Components__CollapseController)

import CookieBannerController from "./cookie_banner_controller"
application.register("cookie-banner", CookieBannerController)

import FoldersController from "./folders_controller"
application.register("folders", FoldersController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModalEventController from "./modal_event_controller"
application.register("modal-event", ModalEventController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import TagsController from "./tags_controller"
application.register("tags", TagsController)

import TimeagoController from "./timeago_controller"
application.register("timeago", TimeagoController)

import TreeController from "./tree_controller"
application.register("tree", TreeController)
